module.exports = __webpack_public_path__ + "img/icon_4_11.466c8b8d.png";